import { render, staticRenderFns } from "./KoioteTankCanvasQuesos.vue?vue&type=template&id=76b20166&scoped=true"
import script from "./KoioteTankCanvasQuesos.vue?vue&type=script&lang=js"
export * from "./KoioteTankCanvasQuesos.vue?vue&type=script&lang=js"
import style0 from "./KoioteTankCanvasQuesos.vue?vue&type=style&index=0&id=76b20166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b20166",
  null
  
)

export default component.exports